import React, { useState, useMemo } from "react";
import { Layout, Typography, Card, Row, Col, Button, Input, Pagination } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const ebooks = [
  { id: 1, title: "AI for Beginners", author: "John Doe", description: "An introductory guide to AI fundamentals.", image: "https://via.placeholder.com/200" },
  { id: 2, title: "Cybersecurity Essentials", author: "Jane Smith", description: "Key concepts and best practices in cybersecurity.", image: "https://via.placeholder.com/200" },
  { id: 3, title: "Data Science Handbook", author: "Alex Johnson", description: "Comprehensive resource for data science professionals.", image: "https://via.placeholder.com/200" },
  { id: 4, title: "Machine Learning Applications", author: "Emily Davis", description: "Real-world applications of machine learning.", image: "https://via.placeholder.com/200" },
  { id: 5, title: "Deep Learning Basics", author: "Michael Brown", description: "A beginner’s guide to understanding deep learning techniques.", image: "https://via.placeholder.com/200" },
  { id: 6, title: "Advanced Cybersecurity Strategies", author: "Sarah Wilson", description: "In-depth strategies for protecting against modern cyber threats.", image: "https://via.placeholder.com/200" },
  { id: 7, title: "Data Visualization with Python", author: "David Lee", description: "Master data visualization using Python libraries.", image: "https://via.placeholder.com/200" },
  { id: 8, title: "AI in Business", author: "Laura Adams", description: "How AI transforms business operations and decision-making.", image: "https://via.placeholder.com/200" },
  { id: 9, title: "Ethical Hacking Guide", author: "Chris Evans", description: "Learn ethical hacking techniques to secure systems.", image: "https://via.placeholder.com/200" },
  { id: 10, title: "Big Data Analytics", author: "Rachel Green", description: "Exploring big data tools and analytics for insights.", image: "https://via.placeholder.com/200" },
];

const Ebooks = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8;

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to first page on new search
  };

  const filteredEbooks = useMemo(() => {
    const query = searchQuery.toLowerCase();
    return ebooks.filter(
      (ebook) =>
        ebook.title.toLowerCase().includes(query) ||
        ebook.description.toLowerCase().includes(query)
    );
  }, [searchQuery]);

  const paginatedEbooks = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return filteredEbooks.slice(startIndex, startIndex + pageSize);
  }, [filteredEbooks, currentPage]);

  return (
    <Layout>
      <Content style={{ padding: "50px", background: "#f0f2f5" }}>
        <Title level={2} style={{ fontSize: "24px", color: "#1890ff" }}>
          Ebooks
        </Title>
        <Paragraph style={{ fontSize: "16px", color: "#666", marginBottom: "24px" }}>
          Explore our collection of ebooks covering AI, Cybersecurity, and Data Science.
        </Paragraph>

        <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
          <Col xs={24} md={12}>
            <Input
              placeholder="Search ebooks by title or description"
              prefix={<SearchOutlined />}
              size="large"
              value={searchQuery}
              onChange={handleSearchChange}
              style={{ borderRadius: "4px" }}
            />
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          {paginatedEbooks.length > 0 ? (
            paginatedEbooks.map((ebook) => (
              <Col xs={24} sm={12} md={8} lg={6} key={ebook.id}>
                <Card
                  hoverable
                  cover={
                    <img
                      alt={ebook.title}
                      src={ebook.image}
                      style={{ height: "150px", objectFit: "cover" }}
                    />
                  }
                  style={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  bodyStyle={{ flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}
                >
                  <div>
                    <Title level={4} style={{ marginBottom: "8px", color: "#333" }}>
                      {ebook.title}
                    </Title>
                    <Paragraph style={{ color: "#666", fontSize: "14px", marginBottom: "8px" }}>
                      <strong>Author:</strong> {ebook.author}
                    </Paragraph>
                    <Paragraph style={{ color: "#666", fontSize: "14px" }}>
                      {ebook.description}
                    </Paragraph>
                  </div>
                  <Button
                    type="primary"
                    href="/signin"
                    style={{ backgroundColor: "#1890ff", borderColor: "#1890ff", width: "100%", marginTop: "16px" }}
                  >
                    Download
                  </Button>
                </Card>
              </Col>
            ))
          ) : (
            <Col span={24} style={{ textAlign: "center" }}>
              <Paragraph style={{ color: "#999", fontSize: "16px" }}>
                No ebooks match your search. Try a different query!
              </Paragraph>
            </Col>
          )}
        </Row>

        <Pagination
          current={currentPage}
          total={filteredEbooks.length}
          pageSize={pageSize}
          onChange={setCurrentPage}
          style={{ marginTop: "24px", textAlign: "center" }}
          showSizeChanger={false}
        />
      </Content>
    </Layout>
  );
};

export default Ebooks;